import { useEffect, useRef, useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { processSession } from '../lib/api';
import { Loader2 } from 'lucide-react';

const ONIRVA_ICON = "https://customer-assets.emergentagent.com/job_200ec0e0-0820-4417-b1b5-b6286eb18bc4/artifacts/c3nyk9fu_80AC8250-CA42-4BF9-BA0D-F1211AA6A764.png";

export default function AuthCallback() {
  const navigate = useNavigate();
  const location = useLocation();
  const hasProcessed = useRef(false);
  const [error, setError] = useState(null);
  
  useEffect(() => {
    // Prevent double processing in StrictMode
    if (hasProcessed.current) return;
    hasProcessed.current = true;
    
    const processAuth = async () => {
      try {
        // Extract session_id from URL fragment
        const hash = window.location.hash;
        const params = new URLSearchParams(hash.replace('#', ''));
        const sessionId = params.get('session_id');
        
        if (!sessionId) {
          throw new Error('No session ID found');
        }
        
        // Exchange session_id for user data
        const response = await processSession(sessionId);
        const user = response.data;
        
        // Store user data
        localStorage.setItem('onirva_user', JSON.stringify(user));
        
        // Clear the URL fragment
        window.history.replaceState(null, '', window.location.pathname);
        
        // Navigate based on onboarding status
        if (user.has_completed_onboarding) {
          navigate('/dashboard', { state: { user }, replace: true });
        } else {
          navigate('/onboarding', { state: { user }, replace: true });
        }
      } catch (err) {
        console.error('Auth callback error:', err);
        setError('Authentication failed. Please try again.');
        setTimeout(() => navigate('/login'), 2000);
      }
    };
    
    processAuth();
  }, [navigate]);
  
  return (
    <div className="min-h-screen bg-background flex items-center justify-center">
      <div className="text-center">
        <img src={ONIRVA_ICON} alt="ONIRVA" className="w-16 h-16 mx-auto mb-4 rounded-2xl animate-pulse" />
        {error ? (
          <p className="text-destructive">{error}</p>
        ) : (
          <>
            <Loader2 className="w-8 h-8 animate-spin mx-auto mb-4 text-primary" />
            <p className="text-muted-foreground">Completing sign in...</p>
          </>
        )}
      </div>
    </div>
  );
}
